module.exports = __webpack_public_path__ + "sam1-b4ba6ba8107957838112b94516e18015.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/sam1.png
// module id = jq96
// module chunks = client